import * as React from 'react'
import { Select, Empty, Row } from 'antd'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { inject, observer } from 'mobx-react'
import Helmet from 'react-helmet'
import { ReceiptFormV1 } from './ReceiptFormV1'
import { ReceiptFormV2 } from './ReceiptFormV2'
import { LocationModels } from '@getgreenline/locations'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  selectedLocationId?: number
  selectedLocation?: LocationModels.ILocationContract
}

@inject('currentCompanyStore')
@observer
export class Receipts extends React.Component<Props, State> {
  company = this.props.currentCompanyStore!.company!

  constructor(props: Props) {
    super(props)

    this.state = {
      selectedLocationId: undefined,
      selectedLocation: undefined,
    }
  }

  componentDidMount = async () => {
    const locations = await this.props.currentCompanyStore!.getLocations()
    this.selectLocation(locations[0].id)
  }

  selectLocation = (selectedLocationId: number) => {
    const locations = this.props.currentCompanyStore!.locations || []
    const matchingLocation = locations.find((location) => location.id === selectedLocationId)

    if (!matchingLocation) {
      return
    }

    this.setState({
      selectedLocationId: selectedLocationId,
      selectedLocation: matchingLocation,
    })
  }

  render() {
    const { selectedLocationId, selectedLocation } = this.state

    const locations = this.props.currentCompanyStore!.locations || []

    return (
      <Row className='white-rounded-container'>
        <Helmet>
          <title>Settings | Receipts</title>
          <meta name='page-loaded' content='true' />
        </Helmet>

        <div className='d-flex flex-column row'>
          <section className='col-lg-4 col-md-5 col-sm-6 mb-4'>
            <label className='font-weight-bold'>Select location</label>
            <div>
              <Select<number>
                allowClear
                placeholder='Select location'
                style={{ width: '100%' }}
                value={selectedLocationId}
                onChange={(locationId) => {
                  if (locationId) {
                    this.selectLocation(locationId)
                  } else {
                    this.setState({ selectedLocationId: undefined })
                  }
                }}
              >
                {locations.map((location) => {
                  return (
                    <Select.Option key={location.id} value={location.id}>
                      {location.name}
                    </Select.Option>
                  )
                })}
              </Select>
            </div>
          </section>
        </div>

        <hr />

        {selectedLocationId ? (
          this.props.currentCompanyStore!.canUseCustomReceipt && selectedLocation ? (
            <ReceiptFormV2 selectedLocation={selectedLocation} />
          ) : (
            <ReceiptFormV1 selectedLocationId={selectedLocationId} />
          )
        ) : (
          <Empty description='Select location' />
        )}
      </Row>
    )
  }
}
